export interface PatientId {
	patientIdListKey?:number;
	patientPersonKey?:number;
	description?:string;
	patientId:string;
	primary:string; // Y/N
	sequenceId?:number;
	issuerOfPidKey?:number;
	issuerOfPid?:string;
	displaySortOrder?:number;
	isPrevious?:boolean;

	/* tslint:disable */
	FKLookupRows?: any;
	/* tslint:enable */
}

export enum PatientIdValidation {
	Valid,
	NotValid,
	Exists,
	Unknown
}
